var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduleMessageProviderSender = function SvgScheduleMessageProviderSender(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#ECF1F3",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A657B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.648 8.645h-2.83c-3.17 0-5.75 2.579-5.75 5.749v2.1c0 .25.203.452.453.452h13.424c.25 0 .452-.202.452-.452v-2.1c0-3.17-2.58-5.749-5.749-5.749zm1.258 4.008c.345 0 .626.281.626.626s-.281.626-.626.626-.626-.28-.626-.626c0-.345.28-.626.626-.626zm3.587 3.39H.973v-1.65c0-2.014 1.236-3.745 2.99-4.474v1.799h-.244c-.725 0-1.315.59-1.315 1.314v1.325c0 .25.203.452.452.452.25 0 .452-.202.452-.452v-1.325c0-.226.185-.41.41-.41h1.359c.226 0 .41.184.41.41v1.325c0 .25.202.452.452.452s.452-.202.452-.452v-1.325c0-.725-.59-1.314-1.314-1.314h-.21V9.643c.307-.061.625-.094.95-.094h2.831c.275 0 .543.024.806.068v2.2c-.624.194-1.078.776-1.078 1.462 0 .844.686 1.53 1.53 1.53.843 0 1.53-.686 1.53-1.53 0-.686-.455-1.268-1.078-1.462V9.862c1.83.692 3.135 2.462 3.135 4.532v1.648zM7.807 1.613L6.903 1.613 6.903 2.173 6.343 2.173 6.343 3.077 6.903 3.077 6.903 3.636 7.807 3.636 7.807 3.077 8.367 3.077 8.367 2.173 7.807 2.173z",
    transform: "translate(8 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.233 8.245c2.04 0 3.701-1.66 3.701-3.701V.542c0-.25-.202-.452-.452-.452H3.983c-.25 0-.452.203-.452.452v4.002c0 2.04 1.66 3.701 3.702 3.701zM4.435.995h5.595v3.097H4.435V.994zm5.559 4c-.217 1.33-1.373 2.346-2.761 2.346-1.389 0-2.545-1.017-2.761-2.345h5.522z",
    transform: "translate(8 7)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleMessageProviderSender);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-message-provider-sender.ee005043181ad6d114299d6007b31c96.svg";